import { format, isToday, parseISO } from "date-fns";
import type { FC } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "../tooltip";

interface ConversationLinkDateProps {
  date: string;
}

export const ConversationLinkDate: FC<ConversationLinkDateProps> = ({ date }) => {
  const parsed = parseISO(date);
  const now = new Date();

  let formatted: string;
  if (isToday(parsed)) {
    formatted = format(parsed, "h:mm a");
  } else if (parsed.getFullYear() === now.getFullYear()) {
    formatted = format(parsed, "LLL d");
  } else {
    formatted = format(parsed, "M/d/y");
  }

  const fullDate = format(parsed, "LLL d, yyyy, h:mm aa");

  return (
    <Tooltip delayDuration={500}>
      <TooltipTrigger asChild>
        <div className="whitespace-nowrap">{formatted}</div>
      </TooltipTrigger>
      <TooltipContent>{fullDate}</TooltipContent>
    </Tooltip>
  );
};
